import { useMemo } from 'react';
import { getBooleanConfig } from '@zg-rentals/frontend-config/client';
import { METROID_CONFIG_URL, METROID_HPP_CONFIG_ID } from '../constants/metroid';

export function useMetroidConfig() {
  const isUatEnabled = getBooleanConfig('isMetroidUatEnabled', false);
  return useMemo(() => {
    // though this app is serverless, locally Next uses dev server and window is undefined
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';

    if (hostname === 'www.zillow.com') {
      return { metroidConfigUrl: METROID_CONFIG_URL.PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.PROD };
    }

    if (isUatEnabled) {
      return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD_UAT, metroidHPPConfigId: METROID_HPP_CONFIG_ID.UAT };
    }

    switch (hostname) {
      case 'www.qa.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.QA };
      case 'www.ra1.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.RA1 };
      case 'www.ra2.zillow.net':
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.RA2 };
      default:
        // localhost
        return { metroidConfigUrl: METROID_CONFIG_URL.NON_PROD, metroidHPPConfigId: METROID_HPP_CONFIG_ID.LOCAL };
    }
  }, [isUatEnabled]);
}
